import { Button } from '@/components/atoms';
import { routes } from '@/lib/constants';
import { GiftIcon } from 'lucide-react';
import { Link } from 'react-router';

function ReferEarnHeaderButton() {
  return (
    <Button
      asChild
      variant="outline"
      size="sm"
      className="rounded-full border-primary/20 bg-primary/5 text-primary hover:bg-primary/10"
    >
      <Link to={routes.referAndEarn}>
        <GiftIcon />
        <span className="max-sm:sr-only">Refer & Earn</span>
      </Link>
    </Button>
  );
}

export { ReferEarnHeaderButton };
